import Navbar from "../../components/global/Navbar";
import Footer from "../../components/global/Footer";
import Copyright from "../../components/global/Copyright";

const PagesLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <Copyright /> 
    </>
  )
}

export default PagesLayout
